import React from 'react';
import { IconButton } from 'theme-ui';

function ExplorerPlusIcon() {
  return (
    <IconButton>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        stroke="currentColor"
      >
        <path
          strokeWidth="2"
          d="M8 2.343v11.314M13.657 8H2.343"
          opacity="0.4"
        />
      </svg>
    </IconButton>
  );
}

export default ExplorerPlusIcon;
